import { render, staticRenderFns } from "./DevWarning.vue?vue&type=template&id=493f52ba&scoped=true"
import script from "./DevWarning.vue?vue&type=script&lang=js"
export * from "./DevWarning.vue?vue&type=script&lang=js"
import style0 from "./DevWarning.vue?vue&type=style&index=0&id=493f52ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f52ba",
  null
  
)

export default component.exports